import type { SlotProps } from "@radix-ui/react-slot";
import type { RegionSelectionHandlerFragment } from "../client/generated";
import type { EditorAction } from "../editor/reducers";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "@acdc2/ui/lib/utils";
import { useState } from "react";

type Props = SlotProps & {
  fragment: RegionSelectionHandlerFragment;
  dispatch: React.Dispatch<EditorAction>;
};

export function RegionSelectionHandler({
  fragment,
  dispatch,
  children,
  className,
  ...props
}: Props) {
  const [isMouseDown, setIsMouseDown] = useState(false);

  const onMouseDown = () => {
    setIsMouseDown(true);
  };

  const onFocus = () => {
    if (isMouseDown) return;
    dispatch({
      type: "selectRegion",
      regionId: fragment.id,
    });
  };

  const onMouseUp = () => {
    setIsMouseDown(false);
  };

  const onClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    dispatch({
      type: "selectRegion",
      regionId: fragment.id,
    });
  };

  const onContextMenu = () => {
    dispatch({
      type: "selectRegion",
      regionId: fragment.id,
    });
  };

  return (
    <Slot {...props}>
      <Slot
        onMouseDown={onMouseDown}
        onFocus={onFocus}
        onMouseUp={onMouseUp}
        onClick={onClick}
        onContextMenu={onContextMenu}
        tabIndex={0}
        className={cn("cursor-pointer", className)}
      >
        {children}
      </Slot>
    </Slot>
  );
}
